import { RefObject ,createRef} from "react"

export type PrintConextType = {
     iframeRef:RefObject<HTMLIFrameElement | null>
}

export const initialPrintContextData:PrintConextType = {
    iframeRef:createRef<HTMLIFrameElement|null>()
}